import { useLocation } from 'react-router-dom'
import { useMemo } from 'react'
import AdSlot from './AdSlot'
import '../assets/css/Ad.css'

function TopBillboardLayout({unitPath, divId}) {
    const location = useLocation();
    const sizes = useMemo(() => [[970, 250], [300, 250]], []);
    const mappingConfig = useMemo(() => [
        { viewport: [1024, 0], slotSizes: [[970, 250]] }, 
        { viewport: [0, 0], slotSizes: [[300, 250]] }  
    ], []);

    return (
        <div className="top-billboard">
            <AdSlot 
                key={location.pathname}
                divId={divId}
                unitPath={unitPath}
                sizes={sizes}
                mappingConfig={mappingConfig} 
            />
        </div>
    )
}

export default TopBillboardLayout;